import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Warning:`}</strong>{` This is a community maintained crate, and is still under development. It is not officially supported by PostHog.`}</p>
    </blockquote>
    <p>{`Install the `}<inlineCode parentName="p">{`posthog-rs`}</inlineCode>{` crate by adding it to your `}<inlineCode parentName="p">{`Cargo.toml`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-toml",
        "metastring": "file=Cargo.toml",
        "file": "Cargo.toml"
      }}>{`[dependencies]
posthog-rs = "0.2.0"
`}</code></pre>
    <p>{`Next, set up the client with your PostHog project key.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-rust"
      }}>{`let client = posthog_rs::client(env!("<ph_project_api_key>"));
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` Currently, there is no way to customize the host that events are sent to, and we default to `}<inlineCode parentName="p">{`app.posthog.com`}</inlineCode></p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      